<section>

  <div class="flex justify-between items-end" >
    <div>
      <h1>Students</h1>
    </div>
    <div class="flex items-center gap-3">
      <div class="dropdown dropdown-bottom dropdown-end" *ngIf="file_import_export === true"> 
        <div tabindex="0" role="button" class="btn btn-sm bg-white  border flex items-center">Action <i
            class="ri-arrow-down-s-line"></i></div>
        <ul tabindex="0"
          class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
          <li *ngIf="import_file === true"><label for="student-import-file" class="cursor-pointer">Import via CSV</label></li>
          <li *ngIf="export_file === true"><a (click)="exportData('pdf')">Export PDF</a></li>
          <li *ngIf="export_file === true"><a (click)="exportData('csv')">Export CSV</a></li>
          <li *ngIf="export_file === true"><a (click)="exportData('excel')">Export Excel</a></li>
        </ul>
      </div>
      <input id="student-import-file" type="file" accept=".csv" class="hidden" (change)="handleImportFile($event)" />
      <a *ngIf="create_student === true" (click)="showStudentFormModal('new')" class="btn btn-sm flex items-center btn-primary"><i
          class="ri-add-line"></i> Create Student</a>

    </div>
  </div>




  <div *ngIf="student_list === true">

    <!-- serach Parameter form -->
  @if (student_list === true) {
  <form [formGroup]="serachFiledForm" (submit)="onSearchSubmit()">
    <div class="flex flex-wrap justify-between items-center mt-5 gap-3">
      <div class="flex flex-wrap items-center gap-3">

        <select  *ngIf="course_filter === true"  formControlName="department" class="select select-sm select-bordered w-32 text-xs font-semibold"
          (change)="setFields($event, 'department')">
          <option selected [value]="null">Departments</option>

          @if (departments && departments.length == 0) {
          <option disabled>No Departments</option>
          }@else {
          @for (i of departments || []; track $index) {
          <option class="text-sm font-medium" [value]="i?.id">{{ i?.department_name }}</option>
          }
          }
        </select>

        <select *ngIf="course_filter === true" formControlName="class" class="select select-sm select-bordered w-32 text-xs font-semibold"
          (change)="setFields($event, 'class')">
          <option selected [value]="null">Class</option>
          @if (classes && classes.length == 0) {
          <option disabled>No Classes</option>
          }@else {
          @for (i of classes || []; track $index) {
          <option class="text-sm font-medium" [value]="i?.id">{{ i?.class_name }}</option>
          }
          }
        </select>
        <select *ngIf="course_filter === true" formControlName="batch" class="select select-sm select-bordered w-32 text-xs font-semibold">
          <option selected [value]="null">Batch</option>
          @if (batches && batches.length == 0) {
          <option disabled>No Batches</option>
          } @else {
          @for (i of batches || []; track $index) {
          <option class="text-sm font-medium" [value]="i?.id">{{ i?.batch_name }}</option>
          }
          }
        </select>


        <select *ngIf="date_filter === true" formControlName="academic_year" class="select select-sm select-bordered w-32 text-xs font-semibold">
          <option selected [value]="null">Academic Year</option>
          @let academicYear = (academicYear$ | async);
          @if (!academicYear?.data?.length) {
          <option disabled>No Academic Years</option>
          } @else {
          @for (i of academicYear.data || []; track $index) {
          <option class="text-sm font-medium" [value]="i?.id">{{i.alias}}</option>
          }
          }
        </select>
        <select formControlName="status" class="select select-sm select-bordered w-32 text-xs font-semibold">
          <option selected [value]="null">status</option>
          <option value="1" class="text-sm font-medium">Active</option>
          <option value="0" class="text-sm font-medium">Inactive</option>
        </select>
      </div>

      <div class="flex items-center gap-3">
        <label class="input input-sm input-bordered flex items-center gap-2">
          <i class="ri-search-line"></i>
          <input formControlName="search" type="text" class="grow" placeholder="Search" />
        </label>

        <button type="submit" class="btn btn-sm "><i class="ri-filter-3-line"></i> Apply</button>
        @if (isFilterApplied) {
        <button type="submit" class="btn btn-sm " (click)="resetSearchForm()"> Clear</button>
        }
      </div>

    </div>
  </form>
  <!-- serach Parameter form -->
  <div *ngIf="selectedCount > 0" class="flex flex-wrap items-center justify-between gap-3 my-4 bg-slate-100 border rounded-md px-4 py-2 mb-3">
    <div class="font-semibold text-sm">{{ selectedCount }} Selected</div>
    <div class="flex flex-wrap items-center gap-2">
      <button class="btn btn-sm btn-light">Update Course</button>
      <button class="btn btn-sm btn-light">Add to Group</button>
      <button class="btn btn-sm btn-light">Move</button>
      <button class="btn btn-sm btn-light">Deactivate</button>
    </div>
    <div class="flex items-center gap-2">
      <button class="btn btn-sm btn-error text-white">Delete Selected</button>
    </div>
  </div>

  <div class="p-5 bg-white rounded-lg mt-5 border"*ngIf="view_student === true">

    <div class="overflow-x-auto" >
      <table class="table table-auto w-full">
        <!-- head -->
        <thead>
          <tr>
            <th class="w-14">
              <input type="checkbox" class="checkbox checkbox-sm"
                [checked]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                (change)="toggleSelectAll($event)" />
            </th>
            <th class="w-auto">Student Name</th>
            <th>Contact Details</th>
            <th>acedemic Year</th>
            <th *ngIf="delete_student === true">status</th>
            <th class="w-56" *ngIf="actions === true">Action</th>
          </tr>
        </thead>
        <tbody>
          @if (isFetching) {
          <tr>
            <td colspan="6" class="py-10">
              <div class="flex justify-center">
                <app-loader></app-loader>
              </div>
            </td>
          </tr>
          } @else {
          @if (studenList && studenList.length) {
          @for (i of studenList; track $index) {
          <tr>
            <th>
              <input type="checkbox" class="checkbox checkbox-sm"
                [checked]="isSelected(i, $index)"
                (change)="toggleRowSelection($event, i, $index)" />
            </th>
            <td class="break-words">{{i?.first_name}}</td>
            <td class="flex flex-col">
              <span>{{i?.mobile}}</span>
              <span>{{i?.email_id}}</span>
            </td>
            <td>{{ getAcademicYearLabel(i?.admission?.academic_year) }}</td>
            <td>
              <div class="flex items-center   gap-2"*ngIf="delete_student === true">
                <input type="checkbox"
                  class="toggle toggle-sm toggle-success checked:[--tglbg:#22c55e] checked:bg-white"
                  [checked]="i?.is_active ?? false" (change)="toggleStatus($event, i?.id)" />
                <i id="status_loader_{{i?.id}}" class="ri-loader-2-line animate-spin hidden"></i>
                <div id="status_message_{{i?.id}}">
                  @if (i.is_active ?? false) {
                  <span class="badge bg-green-500 text-white">Active</span>
                  } @else {
                  <span class="badge bg-red-500 text-white">Inactive</span>
                  }
                </div>
              </div>
            </td>
            <td  *ngIf="actions === true">
              <div class="flex gap-2 justify-center">
                <!-- <a *ngIf='view_student === true' [routerLink]="['/student', i?.id]" class="btn btn-sm flex items-center btn-light"><i
                    class="ri-eye-line"></i></a> -->
                <a *ngIf="edit_student ===  true" (click)="showStudentFormModal('edit',i?.id)" class="btn btn-sm flex items-center btn-light"><i
                    class="ri-pencil-line"></i></a>
                <button *ngIf="delete_student === true" [disabled]="!i?.is_active" class="btn btn-sm flex items-center btn-light"
                  (click)="deleteStudent(i?.id)"><i class="ri-delete-bin-line"></i></button>
                <a *ngIf="performance ===  true"  [routerLink]="['/student',i?.id]" class="btn btn-sm flex items-center btn-light"><i
                    class="ri-bar-chart-line"></i></a>
                <button  (click)="openChat(i.id)" class="btn btn-sm flex items-center btn-light"><i class="ri-message-3-line"></i></button>
              </div>
            </td>
          </tr>
          }
          } @else {
          <tr>
            <td colspan="6" class="py-10">
              <div class="flex justify-center">
                <p>No data to display.</p>
              </div>
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>



  </div>



  <div class="mt-5 flex justify-center">
    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
  </div>
  }
  </div>
</section>
<!-- create/edit student modal -->
@if (isMoaldalOpen) {
<app-student-form-modal [studentId]="studentId" [isOpen]="isMoaldalOpen"
  (closeModalemmit)="emitedData($event)"></app-student-form-modal>
}
<!-- create/edit student modal -->
